<template>
  <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="9" md="4">
        <WriteoffFormsSearchForm
          @submit="search"
        />
      </v-col>
      <v-col cols="auto" style="display: flex; flex-direction: column;">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyWriteoffFormsNew'})"
        >
          Vnos
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text mt-4"
          @click="printListAcceptanceForms"
        >
        Tiskaj
        <v-icon right dark>mdi-printer</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  Št. odpisa
                </th>
                <th>
                  Komentar
                </th>
                <th>
                  Datum
                </th>
                <th>
                  Vrednost
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="writeOffForm in writeoffForms"
                :key="writeOffForm.id"
              >
                <td>{{writeOffForm.label}}</td>
                <td>{{writeOffForm.comment}}</td>
                <td>{{writeOffForm.date | sloDate}}</td>
                <td>{{writeOffForm.total_amount | price}}</td>
                <td>
                  <ButtonActionEdit @click="$router.push({name: 'MyCompanyWriteoffFormsEdit', params: {id: writeOffForm.id}})" />
                  <ButtonActionPrint @click="printAcceptanceForm(writeOffForm.id)" />
                  <ButtonActionDelete @click="showDeleteAcceptanceFormModal = true; deleteAcceptanceForm = writeOffForm" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje odpisa"
      text="Ali ste prepričani, da želite izbrisati odpis? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteAcceptanceFormModal"
      @confirmed="remove(deleteAcceptanceForm)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ButtonActionPrint from '@/components/ButtonActionPrint'
import WriteoffFormsSearchForm from '@/components/WriteoffFormsSearchForm'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionPrint,
    WriteoffFormsSearchForm
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      writeoffForms: [],
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null
    }
  },
  methods: {
    ...mapActions('writeoffForms', ['loadItems', 'deleteItem', 'setFilters']),
    printAcceptanceForm (idwoform) {
      let routeData = this.$router.resolve({ name: 'MyCompanyWriteoffFormPreview', params: { id: idwoform } })
      window.open(routeData.href, '_blank')
    },
    printListAcceptanceForms () {
      let routeData = this.$router.resolve({ name: 'MyCompanyWriteoffFormsPreview', query: this.$store.state.writeoffForms.filters })
      window.open(routeData.href, '_blank')
    },
    remove (item) {
      this.deleteItem(item.id)
        .then(() => {
          this.doLoadItems(this.$store.state.writeoffForms.filters)
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    search (form) {
      const filters = {}
      if (form.startDate) {
        filters.dateFrom = form.startDate
      }
      if (form.endDate) {
        filters.dateTo = form.endDate
      }
      if (form.label) {
        filters.label = form.label
      }
      if (form.deliveryDocument) {
        filters.deliveryDocument = form.deliveryDocument
      }
      if (form.includeArticles) {
        filters.includeArticles = form.includeArticles
      }
      this.setFilters(filters)
      this.doLoadItems(filters)
    },
    doLoadItems (filters) {
      this.loadItems({ filters })
        .then(res => {
          this.writeoffForms = objectToArray(res)
        })
    },
    searchLastFilters () {
      const filters = this.$store.state.writeoffForms.filters
      if (filters) {
        this.doLoadItems(filters)
      }
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.searchLastFilters()
      this.asyncDataStatus_fetched()
    }
  }
}
</script>
